import envConfig from '../envConfig'
import PermissionsUtil from '../helpers/permissions/PermissionsUtil'
import { isFeatureAllowed, combinePathsWithEnv } from '../helpers/routeUtil'
import Locations from '../helpers/tools/locations'
import { MicroApp } from '../types/microApp'

const { permissions } = PermissionsUtil

const App: MicroApp = {
  name: 'payment_links',
  importFunction: async (version: string) => System.import(`${envConfig.apps.paymentLinks}app.${version}.js`),
  getVersion: async (): Promise<string> => {
    const version = await System.import(`${envConfig.apps.paymentLinks}version.js?c=${Date.now()}`)
    return version.default
  },
  permissionsCheck: (): boolean => {
    const requiredPermissions = [
      permissions.payments.get
    ]
    return isFeatureAllowed(PermissionsUtil.all, requiredPermissions)
  },
  paths: combinePathsWithEnv([Locations.paymentLinkDetailsPage,
    Locations.createPaymentLinkPage,
    Locations.paymentLinksPage])
}

export default App
